export const Roles = {
    ORGANIZATION_STANDARD: 'OrganizationStandard',
    PLATFORM_ADMIN: 'PlatformAdmin',
}